// Kişiler: yüklenen Excel listeleri (soldan seç, sağda kişileri gör). Listeler Mesaj Gönder'de kaynak olarak seçilir.
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import cs from 'classnames';
import moment from 'moment';
import { getContactLists, deleteContactList, getContactListPage, getContactListItems } from '../../util/contacts';
import { Btn, IconBtn, Card, CardHead, PageHead, SearchInput, Tag, Empty, Loading, ConfirmModal, Pager, Spinner, notify, num, paginate, searchMatch, downloadSheets } from './ui';
import ImportModal from './importmodal';

const PAGE_SIZE = 50;
const PREVIEW_LIMIT = 1000;

class Phones extends Component {
	state = { loading: true, list: [], rows: [], q: '', page: 1 };
	componentDidMount() {
		this.getList();
	}
	componentWillUnmount() {
		clearTimeout(this.searchTimer);
	}
	getList(selectId) {
		return getContactLists()
			.then((list) => {
				let keep = selectId || (this.state.selected && this.state.selected.id);
				let selected = _.find(list, (it) => String(it.id) === String(keep)) || list[0] || null;
				this.setState({ list, loading: false });
				this.select(selected);
			})
			.catch(() => {
				this.setState({ loading: false });
				notify(this.props.t('Listeler alınamadı.'), 'err');
			});
	}
	select(selected, q = '') {
		this.setState({ selected, q, page: 1, rows: [] });
		if (selected) this.loadRows(selected, q);
	}
	// İlk 1000 kişi; arama sunucuda yapılır.
	loadRows(selected, q) {
		let req = (this.req = {});
		this.setState({ rowsLoading: true });
		getContactListPage(selected.id, { limit: PREVIEW_LIMIT, q: q || undefined })
			.then((page) => req === this.req && this.setState({ rows: page.data || [], rowsLoading: false }))
			.catch(() => req === this.req && this.setState({ rowsLoading: false }));
	}
	onSearch = (q) => {
		this.setState({ q, page: 1 });
		clearTimeout(this.searchTimer);
		this.searchTimer = setTimeout(() => this.state.selected && this.loadRows(this.state.selected, q), 400);
	};
	deleteList() {
		let { toDelete } = this.state;
		this.setState({ deleting: true });
		deleteContactList(toDelete.id)
			.then(() => {
				this.setState({ deleting: false, toDelete: null });
				notify(this.props.t('Liste silindi.'));
				this.getList();
			})
			.catch(() => {
				this.setState({ deleting: false });
				notify(this.props.t('Liste silinemedi.'), 'err');
			});
	}
	exportList() {
		let { selected } = this.state;
		this.setState({ exporting: true });
		getContactListItems(selected.id)
			.then((items) =>
				downloadSheets((selected.name || 'liste').replace(/[^\w-]+/g, '_'), [
					{
						name: 'contacts',
						x: ['Name', 'Phone', 'Label'],
						datasets: _.map(items, (it) => ({ Name: it.Name || '', Phone: it.Phone || '', Label: (it.tags || []).join(',') })),
					},
				])
			)
			.catch(() => notify(this.props.t('Dışa aktarılamadı.'), 'err'))
			.finally(() => this.setState({ exporting: false }));
	}
	render() {
		const { t } = this.props;
		let { loading, list, selected, rows, rowsLoading, q, page, importOpen, toDelete, deleting, exporting } = this.state;
		let total = _.sumBy(list, (it) => it.row_count || 0);
		let listQ = this.state.listQ || '';
		let lists = _.filter(list, (it) => searchMatch(listQ, it.name));
		return (
			<div>
				<PageHead
					title={t('contacts')}
					desc={t('Yüklenen Excel listeleri. Mesaj Gönder sekmesinde liste olarak seçilir.')}
					right={
						<>
							<a className="wsm-btn ghost" href="/contacts_example.xlsx" download="contacts_example.xlsx" target="_blank" rel="noopener noreferrer">
								{t('example download')}
							</a>
							<Btn icon="upload" onClick={() => this.setState({ importOpen: true })}>
								{t('Yeni Excel yükle')}
							</Btn>
						</>
					}
				/>
				{loading ? (
					<Loading />
				) : !list.length ? (
					<Empty
						icon="sheet"
						title={t('Henüz liste yok')}
						desc={t('İlk satırı başlık olan bir Excel (Phone, Name, Label) yükleyin.')}
						action={
							<Btn icon="upload" onClick={() => this.setState({ importOpen: true })}>
								{t('Yeni Excel yükle')}
							</Btn>
						}
					/>
				) : (
					<div className="wsm-lists">
						<Card className="wsm-listpanel">
							<div className="wsm-listpanel-head">
								<div className="wsm-hint">
									{num(list.length)} {t('liste')} · {num(total)} {t('kişi')}
								</div>
								{list.length > 6 ? <SearchInput value={listQ} onChange={(v) => this.setState({ listQ: v })} placeholder={t('Liste ara…')} /> : null}
							</div>
							<div className="wsm-listpanel-body">
							{lists.map((it) => (
								<div
									key={it.id}
									role="button"
									tabIndex={0}
									className={cs('wsm-list-item', { on: selected && selected.id === it.id })}
									onClick={() => this.select(it)}
									onKeyDown={(e) => e.key === 'Enter' && this.select(it)}
								>
									<div style={{ flex: 1, minWidth: 0 }}>
										<div className="wsm-list-item-name" title={it.name}>
											{it.name || moment(it.created_at).format('DD.MM.YYYY HH:mm')}
										</div>
										<div className="wsm-list-item-sub">
											{num(it.row_count)} {t('kişi')} · {moment(it.created_at).format('DD.MM.YYYY')}
										</div>
									</div>
									<IconBtn
										icon="trash"
										danger
										title={t('delete')}
										onClick={(e) => {
											e.stopPropagation();
											this.setState({ toDelete: it });
										}}
									/>
								</div>
							))}
							{!lists.length ? <div className="wsm-empty-row">{t('Aramanızla eşleşen kayıt bulunamadı.')}</div> : null}
							</div>
						</Card>
						<Card>
							{selected ? (
								<>
									<CardHead
										title={selected.name || t('Liste')}
										desc={`${num(selected.row_count)} ${t('kişi')} · ${moment(selected.created_at).format('DD.MM.YYYY HH:mm')}`}
										right={
											<Btn variant="ghost" size="s" icon="download" busy={exporting} onClick={() => this.exportList()}>
												{t('Dışa aktar')}
											</Btn>
										}
									/>
									<div className="wsm-section">
										<div className="wsm-row">
											<SearchInput value={q} onChange={this.onSearch} placeholder={t('İsim veya numara ara…')} />
											{rowsLoading ? <Spinner size={16} /> : null}
										</div>
									</div>
									<div className="wsm-table-wrap">
										<table className="wsm-table" style={{ minWidth: 520 }}>
											<thead>
												<tr>
													<th>{t('name')}</th>
													<th>{t('phone')}</th>
													<th>{t('label')}</th>
													<th>Users Id</th>
												</tr>
											</thead>
											<tbody>
												{paginate(rows, page, PAGE_SIZE).map((it, i) => (
													<tr key={it._id || i}>
														<td style={{ fontWeight: 500 }}>{it.Name || <span className="wsm-faint">—</span>}</td>
														<td className="wsm-muted wsm-nowrap">{it.Phone || '—'}</td>
														<td>
															{it.tags && it.tags.length ? (
																<div className="wsm-tags">
																	{it.tags.map((tg) => (
																		<Tag key={tg}>{tg}</Tag>
																	))}
																</div>
															) : (
																<span className="wsm-faint">—</span>
															)}
														</td>
														<td className="wsm-muted">{it['Users Id'] || '—'}</td>
													</tr>
												))}
												{!rows.length && !rowsLoading ? (
													<tr>
														<td colSpan={4} className="wsm-empty-row">
															{q ? t('Aramanızla eşleşen kayıt bulunamadı.') : t('Bu listede kişi yok.')}
														</td>
													</tr>
												) : null}
											</tbody>
										</table>
									</div>
									<Pager
										page={page}
										pageSize={PAGE_SIZE}
										total={rows.length}
										onChange={(p) => this.setState({ page: p })}
										label={rows.length >= PREVIEW_LIMIT ? `${t('ilk')} ${num(PREVIEW_LIMIT)} ${t('kayıt gösteriliyor')}` : `${num(rows.length)} ${t('kişi')}`}
									/>
								</>
							) : null}
						</Card>
					</div>
				)}
				{importOpen ? (
					<ImportModal
						t={t}
						onClose={() => this.setState({ importOpen: false })}
						onImported={(data) => {
							this.setState({ importOpen: false });
							notify(t('Liste içe aktarıldı') + (data.list && data.list.row_count ? ': ' + num(data.list.row_count) + ' ' + t('kişi') : ''));
							this.getList(data.list && data.list.id);
						}}
					/>
				) : null}
				{toDelete ? (
					<ConfirmModal
						title={t('delete')}
						desc={toDelete.name}
						body={t('areYouSureDeleteExcel')}
						confirmText={t('yes')}
						cancelText={t('no')}
						busy={deleting}
						onClose={() => this.setState({ toDelete: null })}
						onConfirm={() => this.deleteList()}
					/>
				) : null}
			</div>
		);
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.live,
	user: state.access.user.loggedUserObj,
});

export default connect(stateToProps)(withTranslation()(Phones));
